import { ParentTotalsSummary } from './ParentTotalsSummary'

const OMIT_FOR_PARENT = new Set([
  'contractedBy',
  'affiliated',
  'contacts',
  'owner',
  'billingContact',
  'social',
  'primaryContact',
  'businessPhone',
  'billingPhone',
  'email',
  'cmsUsed',
  'socialProfiles',
  'geoTargeting',
  'marketingObjective',
  'productsAndServices',
  'street',
  'city',
  'state',
  'zip',
]) // remove Addtl Contacts too

export const parentConfigFromChildSections = (
  childSections: any[],
  totals: { allTotal: number; activeRunningTotal: number; productCount?: number }
) => {
  const filteredSections = (childSections ?? []).map(section => ({
    ...section,
    fields: (section.fields ?? []).filter((f: any) => !OMIT_FOR_PARENT.has(f?.name)),
  }))

  const totalsSection = {
    sectionLabel: 'Totals',
    fields: [
      {
        name: '__parentTotals__',
        label: '',
        type: 'component',
        component: ParentTotalsSummary,
        componentProps: { totals },
        // make it span wide
        gridProps: { xs: 12 },
        value: totals,
        // no-op, because your renderer calls `onChange` for components
        // (this keeps things compatible with your current render loop)
        onChange: () => {},
      },
    ],
  }

  // Put totals at the top
  return [totalsSection, ...filteredSections]
}
